import { useDirtyTracker } from 'lib/context/DirtyTrackerContext';

import { useCloseOnOpenModalsEvent } from './closeOpenModals';

export const useProtectedClose = ({ isOpen, isDirty, handleClose }) => {
  const dirtyTracker = useDirtyTracker();

  const protectedClose = () => {
    if (isDirty !== undefined && dirtyTracker?.handleProtectedAction) {
      dirtyTracker.handleProtectedAction(handleClose);
    } else {
      handleClose();
    }
  };

  useCloseOnOpenModalsEvent(isOpen, protectedClose);

  return protectedClose;
};
